import type { ReactNode } from "react";

export interface TopBarProps {
  brandName: string;
  brandTag?: string;
  /** Sağ tarafta oturum/context alanı. */
  actions?: ReactNode;
  /** Verilirse mobil drawer tetikleyicisi render edilir. */
  onToggleNav?: () => void;
  navOpen?: boolean;
}

export function TopBar({
  brandName,
  brandTag,
  actions,
  onToggleNav,
  navOpen = false,
}: TopBarProps) {
  return (
    <header className="qr-topbar">
      {onToggleNav ? (
        <button
          type="button"
          className="qr-topbar-menu"
          onClick={onToggleNav}
          aria-expanded={navOpen}
          aria-label={navOpen ? "Gezinmeyi kapat" : "Gezinmeyi aç"}
        >
          <span className="qr-topbar-menu-bars" aria-hidden="true" />
        </button>
      ) : null}
      <div className="qr-brand">
        <span className="qr-brand-name">{brandName}</span>
        {brandTag ? <span className="qr-brand-tag">{brandTag}</span> : null}
      </div>
      {actions ? <div className="qr-topbar-actions">{actions}</div> : null}
    </header>
  );
}
